import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Swal from 'sweetalert2';

const DeleteAccount = () => {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Here you would implement the actual account deletion logic
      // For now, we'll just show a success message
      await Swal.fire({
        title: 'Account Deletion Requested',
        text: 'Your account deletion request has been received. We will process it within 30 days.',
        icon: 'success',
        confirmButtonColor: '#EC4899',
      });
      navigate('/');
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error.message,
        icon: 'error',
        confirmButtonColor: '#EC4899',
      });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50 backdrop-blur-sm bg-white/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <a href="/" className="text-pink-400 font-bold text-4xl hover:text-pink-500 transition-colors">
            KinAlma
          </a>
        </div>
      </nav>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Delete Account</h1>
          
          <div className="space-y-6 text-gray-700 mb-8">
            <p>Before proceeding with account deletion, you must respond to our email confmirming account deletion. Also please note:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>All your photos and albums will be permanently deleted</li>
              <li>Shared albums will be removed from all users</li>
              <li>This action cannot be undone</li>
              <li>Data deletion will be completed within 30 days</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Confirm your email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pink-500 focus:ring-pink-500"
              />
            </div>

            <div>
              <label htmlFor="reason" className="block text-sm font-medium text-gray-700">
                Reason for deletion (optional)
              </label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={4}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pink-500 focus:ring-pink-500"
              />
            </div>

            <button
              type="submit"
              disabled={loading || email.length === 0 }
              className="w-full px-4 py-2 bg-red-600 text-white font-medium rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Processing..." : "Request Account Deletion"}
            </button>
          </form>

          <p className="mt-6 text-sm text-gray-500">
            For any questions about account deletion, please contact us at{' '}
            <a href="mailto:support@kinalma.com" className="text-pink-600 hover:text-pink-700">
              accounts@kinalma.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;